import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import shortid from 'shortid'

const MethodologyContainer = styled.div`
  background-color: #3c4252;
  padding: 50px 0px;
`

const Title = styled.h3`
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 0px 0px 20px 0px;
  ${media.md`  
    margin: 0px 0px 30px 0px;
  `};
`

const TextWrapper = styled.div`
  padding: 30px 30px 0px 30px;
  & i {
    color: #ffffff;
    font-size: 35px;
  }
`

const TextTitle = styled.p`
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ffffff;
  margin-top: 5px;
`

const Text = styled.div`
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  & ul {
    margin-bottom: 0;
    padding-left: 20px;
  }
`

const StyledIntro = styled.div`
  color: white;
`

const Methodology = props => {
  const { methodology, introMethodology } = props
  const methodologies = methodology.map(item => (
    <div
      key={`methodology-${item.title}`}
      className="col-md-6 col-lg-6 col-xl-4 mx-auto px-0"
    >
      <TextWrapper key={shortid.generate()}>
        <i className={item.icon} />
        <TextTitle>{item.title.toUpperCase()}</TextTitle>
        <Text dangerouslySetInnerHTML={{ __html: item.text }} />
      </TextWrapper>
    </div>
  ))
  return (
    <MethodologyContainer {...props}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Title className="text-center">Metodología</Title>
            {introMethodology !== '' && (
              <StyledIntro className="text-center">
                {introMethodology}
              </StyledIntro>
            )}
            <div className="row">{methodologies}</div>
          </div>
        </div>
      </div>
    </MethodologyContainer>
  )
}

export default Methodology



// WEBPACK FOOTER //
// ./src/components/section/methodology/methodology.js